import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';
import {FocusEventHandler, ReactNode} from 'react';

interface Props<T extends FieldValues, TTransformedValues = T> {
  children: ReactNode;
  form: UseFormReturn<T, any, TTransformedValues>;
  className?: string;
  onSubmit: SubmitHandler<T>;
  onBeforeSubmit?: () => void;
  onBlur?: FocusEventHandler<HTMLFormElement>;
  id?: string;
}
export function Form<T extends FieldValues, TTransformedValues = T>({
  children,
  onBeforeSubmit,
  onSubmit,
  form,
  className,
  id,
  onBlur,
}: Props<T, TTransformedValues>) {
  return (
    <FormProvider {...form}>
      <form
        id={id}
        onBlur={onBlur}
        className={className}
        onSubmit={e => {
          // prevent parent forms from submitting, if nested
          e.stopPropagation();
          onBeforeSubmit?.();
          form.handleSubmit(onSubmit as unknown as SubmitHandler<TTransformedValues>)(e);
        }}
      >
        {children}
      </form>
    </FormProvider>
  );
}
